import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { useDispatch as useDispatchRedux } from 'react-redux'

import { State } from '../store'

export const useDispatch = () => useDispatchRedux<ThunkDispatch<State, null, AnyAction>>()
